import type {FC} from 'react';
import React from "react";
import PropTypes from 'prop-types';
import {Link as RouterLink, useLocation} from 'react-router-dom';
import {AppBar, Box, Button, Divider, IconButton, Toolbar, Typography} from '@mui/material';
import MenuIcon from '../res/icons/Menu';
import Logo from './Logo';
import {
    sectionsAppLogged,
    sectionsAppLoggedManutentore,
    sectionsAppLoggedBackOffice,
    sectionsAppUnLogged
} from "../constants";
import NavSection from "./NavSection";
import useAuth from "../hooks/useAuth";
import { Role } from 'src/model/types/user';
import AccountPopover from "./AccountPopover";

interface MainNavbarProps {
  onSidebarMobileOpen?: () => void;
}

const MainNavbar: FC<MainNavbarProps> = (props) => {
  const { onSidebarMobileOpen } = props;
    const location = useLocation();
    const {user} = useAuth()

    let section = sectionsAppUnLogged
    if(user  && user.role == Role.amministratore){
        section = sectionsAppLogged
    }else if(user  && (user.role === Role.manutentore
        || user.role === Role.terzo_responsabile || user.role === Role.esco)){
        section = sectionsAppLoggedManutentore
    }else if(user  && user.role == Role.backoffice){
        section = sectionsAppLoggedBackOffice
    }
    return (
        <AppBar
          elevation={0}
          sx={{
            backgroundColor: 'background.paper',
            color: 'text.secondary'
          }}
        >
            <Toolbar sx={{minHeight: 64 }}>
                {
                    section && section.length > 0  && section[0].items.length > 0? (
                        <>
                            <IconButton
                                color="inherit"
                                onClick={onSidebarMobileOpen}
                                sx={{
                                    display: {
                                        md: 'none'
                                    }
                                }}
                                size="large">
                                <MenuIcon fontSize="small" />
                            </IconButton></>
                    ) : null
                }
                <Box sx={{flexGrow: 1}}>
                    {}
                <a href={user ? "/" : "https://catastoenergetico.com"}>
                    <Logo
                  sx={{
                    display: {
                      md: 'inline',
                      xs: 'none'
                    }
                  }}
                />
              </a>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        ml: 2,
                        mr: 1,
                        display: {
                            md: 'flex',
                            xs: 'none',
                        },
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        flexWrap: 'nowrap',
                        gap: 4,
                    }}
                >
                    {section.map((section) => (
                        <NavSection
                            key={section.title}
                            pathname={location.pathname}
                            horizontal
                            sx={{
                                flexGrow: 0,
                                flexShrink: 0,
                                whiteSpace: 'nowrap',
                            }}
                            {...section}
                        />
                    ))}
                </Box>


              <Box
                sx={{
                  alignItems: 'center',
                  display: {
                    md: 'flex',
                    xs: 'flex'
                  },
                    whiteSpace: 'nowrap',
                    minWidth: '150px', // o qualsiasi valore minimo adatto
                    flexShrink: 0,      // evita che venga ristretto
                    overflow: 'hidden', // opzionale
                    textOverflow: 'ellipsis', // opzionale
                }}
              >
                  {
                      user ? (
                          <Box sx={{ ml: 2 }}>
                              <AccountPopover />
                          </Box>
                      ): null /* (
                          <Box sx={{ml: 2}}>
                              <Button variant="contained" href="/login" size="medium" color="secondary">
                                  {i18n.t("accedi")}
                              </Button>
                          </Box>
                      )*/
                  }
              </Box>
            </Toolbar>
            <Divider />
        </AppBar>
    );
};

MainNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default MainNavbar;
